import { useState, useEffect } from 'react';

const MapDrawing = ({ map, selectedOpportunityComps, drawIsOn, setUncapturedMarkers, uwType, polygon, setMapState }) => {
  const [drawEvent, setDrawEvent] = useState(null);

  useEffect(() => {
    if (polygon) {
      polygon.setMap(map);
    }
  }, []);

  useEffect(() => {
    if (!drawIsOn) {
      if (polygon) {                  // remove 
        polygon.setMap(null);
        setMapState({ polygon: null });
      }
      // If draw button is not active, reset map interaction to default
      toggleMapInteraction(true);
      map.setOptions({ draggableCursor: '' });
    }
  }, [drawIsOn, selectedOpportunityComps.map(o => o.id).toString()]);

  useEffect(() => {
    if (drawIsOn && !drawEvent) {
      if (!polygon) {//don't run on mount if polygon exists from last session
        map.setOptions({ draggableCursor: 'crosshair' });
        toggleMapInteraction(false);
        setDrawEvent(window.google.maps.event.addListenerOnce(map, 'mousedown', function (e) {
          drawFreeHand(drawEvent);
        }))
      }
    } else if (!drawIsOn && drawEvent) {
      window.google.maps.event.removeListener(drawEvent);
      setDrawEvent(null);
    }
    return () => {
      if (drawEvent) {
        window.google.maps.event.removeListener(drawEvent);
      }
    }
  }, [drawIsOn, drawEvent]);

  const toggleMapInteraction = (isOn) => {
    map.setOptions({
      draggable: isOn,
      zoomControl: isOn,
      disableDoubleClickZoom: !isOn
    });
  };

  const drawFreeHand = (drawEvent) => {
    let polyline = new window.google.maps.Polyline({ map: map, clickable: false, strokeColor: '#3648eb' });
    const move = window.google.maps.event.addListener(map, 'mousemove', function (e) {
      polyline.getPath().push(e.latLng);
    });
    let mouseup = window.google.maps.event.addListenerOnce(map, 'mouseup', function (e) {
      window.google.maps.event.removeListener(move);
      const path = polyline.getPath();        // get the data for the shape to feed to the Polygon
      polyline.setMap(null);                  // remove line

      let newPolygon = new window.google.maps.Polygon({ map: map, paths: path });    // create polygon from polyline data
      newPolygon.setOptions({
        fillColor: '#3648eb',
        fillOpacity: 0.4,
        strokeColor: '#3648eb',
        strokeOpacity: 1,
        strokeWeight: 2
      })
      newPolygon.setEditable(false);
      const markersOutside = revealOutsidePolygon(newPolygon);

      window.google.maps.event.removeListener(drawEvent);
      window.google.maps.event.removeListener(mouseup);
      toggleMapInteraction(true);
      map.setOptions({ draggableCursor: '' });
      if (markersOutside.length > 0) {
        setUncapturedMarkers(markersOutside, uwType);
      }
      setMapState({ polygon: newPolygon });
    });
  }

  const revealOutsidePolygon = (polygon) => {
    const markersArr = [];

    let previousSelectedOpportunityComps = [...selectedOpportunityComps];
    previousSelectedOpportunityComps.forEach((marker, index) => {
      if (marker.latitude && marker.longitude) {
        let latLng = new window.google.maps.LatLng({ lat: marker.latitude, lng: marker.longitude });
        if (!window.google.maps.geometry.poly.containsLocation(latLng, polygon)) {
          markersArr.push(marker.id);
        }
      }
    });
    
    return markersArr;
  }

  return null;
};

export default MapDrawing
